import React from 'react';
import {Link} from 'react-router-dom';
import LogoImg from "../../assets/images/logo.jpeg";

const Logo = () => {
    return (
        <div className="logo">
            <Link to="/">
                <img 
                    src={LogoImg} 
                    alt="Bright Sun Cleaning and Gardening Services" 
                    style={{ height: '130px' }} // Adjust height as needed
                />
            </Link>
        </div>
    )
}

export default Logo;